import {
  Backdrop,
  Box,
  Fade,
  Grid2 as Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import usePut from "../../../../services/hooks/usePut";
import { dialogStyle } from "../../../../shared/constants/all-constant";
import { apiEndpoints } from "../../../../shared/constants/api-constant";
import { Button, Input } from "../../../../shared/ReusableComponents";
import CloseBtn from "../../../../shared/ReusableComponents/CloseBtn";
import { DateTimeInput } from "../../../../shared/ReusableComponents/DateTimeInput";
import { DateTimeFormats } from "../../../../shared/utils/DateFormatter";
import {
  hideLoader,
  showLoader,
} from "../../../../store/currentPreferencesSlice";

function AdministerDialog(props: any) {
  const tableHeaders = [
    { label: "Medicine", key: "medicineName" },
    { label: "Route", key: "route" },
    { label: "Dose", key: "dose" },
  ];
  const [dose, setDose] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [administerDate, setAdministerDate] = useState<any>(moment());
  const [administerTime, setAdministerTime] = useState<any>(moment());
  const { open, data } = props;
  const effectiveDateTime = moment.utc(data?.startDate).local();
  const selectedStartDate = moment(data?.startDate);

  const { putService } = usePut();
  const dispatch = useDispatch();
  const combinedAdministered = moment(
    moment(administerDate).format("YYYY-MM-DD") +
      " " +
      moment(administerTime).format("HH:mm")
  ).toISOString();

  const handleSubmit = () => {
    const payload = {
      id: data.id,
      dose: dose,
      administerOn: combinedAdministered,
    };
    setIsSubmitted(true);
    if (!dose) return;
    dispatch(showLoader());
    const message = `${data.medicineName} Telephone Order has been Successfully Administered.`;
    putService(apiEndpoints.TELEMEDICATIONS, payload, message).then(() => {
      props.onClose();
      dispatch(hideLoader());
    });
  };

  useEffect(() => {
    data ? setDose(data.dose) : setDose("");
  }, [data]);

  const handleDateChange = (val: any) => {
    setAdministerDate(val);
    const isSameStartDate = selectedStartDate.isSame(val, "day");
    const isToday = moment().isSame(val, "day");

    let defaultTime;
    if (isToday) {
      defaultTime = moment(); // Use current time if it's today
    } else if (isSameStartDate) {
      defaultTime = moment.utc(data?.startDate).local(); // Use original start time
    } else {
      defaultTime = moment(val).startOf("day"); // Default to 00:00 if it's another date
    }

    setAdministerTime(defaultTime);
  };

  const handleTimeChange = (timeVal: any) => {
    const selectedTime = moment(timeVal);
    const now = moment();
    // Prevent time before effectiveDateTime
    if (administerDate.isSame(effectiveDateTime, "day")) {
      if (selectedTime.isBefore(effectiveDateTime)) {
        setAdministerTime(effectiveDateTime.clone());
        return;
      }
    }
    // If current date is selected
    if (administerDate.isSame(now, "day")) {
      const selectedHour = selectedTime.hour();
      const currentHour = now.hour();
      const selectedMinute = selectedTime.minute();
      const currentMinute = now.minute();

      if (selectedHour === currentHour && selectedMinute > currentMinute) {
        // Reset minute to current minute if it goes into the future
        selectedTime.minute(currentMinute);
      }
    }
    setAdministerTime(selectedTime);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => props.onClose()}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={dialogStyle}>
            <CloseBtn onClose={() => props.onClose()} />
            <Box sx={{ textAlign: "center" }}>
              <span
                className="material-symbols-outlined medicine-icon"
                style={{ fontSize: "50px" }}
              >
                vaccines
              </span>
            </Box>

            <div style={{ overflowX: "auto", marginTop: 2 }}>
              <Table
                sx={{
                  mt: 2,
                  "& .MuiTableCell-root": {
                    fontSize: "0.875rem",
                  },
                }}
              >
                <TableHead
                  sx={{
                    backgroundColor: "var(--color-default)",
                    border: "2px solid #F5F5F5",
                  }}
                >
                  <TableRow>
                    {tableHeaders.map((header) => (
                      <TableCell key={header.key}>
                        <strong>{header.label}</strong>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{
                      backgroundColor: "#fff",
                    }}
                    className="tabledata"
                  >
                    <TableCell>{data.medicineName}</TableCell>
                    <TableCell>{data.route}</TableCell>
                    <TableCell>{data.dose}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>

            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid size={6}>
                  <DateTimeInput
                    label="Date"
                    type="date"
                    name="administerDate"
                    format={DateTimeFormats.DateFormat}
                    value={administerDate}
                    required
                    classes="administer-date-picker"
                    minDate={effectiveDateTime}
                    maxDate={moment()}
                    onChange={handleDateChange}
                    isDisabled={true}
                    size="small"
                  />
                </Grid>
                <Grid size={6}>
                  <DateTimeInput
                    label="Time"
                    type="time"
                    name="administerTime"
                    classes="administer-date-picker"
                    format={DateTimeFormats.TimeFormat}
                    value={administerTime}
                    required
                    timeSteps={{ minutes: 1 }}
                    minTime={
                      administerDate.isSame(effectiveDateTime, "day")
                        ? effectiveDateTime
                        : moment(administerDate).startOf("day")
                    }
                    maxTime={
                      administerDate.isSame(moment(), "day")
                        ? moment()
                        : moment(administerDate).endOf("day")
                    }
                    onChange={handleTimeChange}
                    isDisabled={true}
                    size="small"
                  />
                </Grid>
                <Grid size={6}>
                  <span className="grey-background">
                    <Input
                      label="Dose"
                      name="Dose"
                      value={dose}
                      fullWidth
                      required
                      size="small"
                      hasError={
                        isSubmitted && dose === "" ? "Dose is required" : false
                      }
                      onChange={(e: any) => setDose(e.target.value)}
                    />
                  </span>
                </Grid>
                <Grid size={6}>
                  <Input
                    label="Check Initials (N1)"
                    fullWidth
                    disabled
                    name="Check Initials (N1)"
                    value={data.initials}
                    InputLabelProps={{
                      shrink: true,
                      style: { color: "var(--color-border-model)" },
                    }}
                  />
                </Grid>
                <Grid size={6}>
                  <Input
                    label="Counter Signed By (RN)"
                    name="counterSignedBy"
                    value={`${data.counterSignedBy} (RN)`}
                    required
                    disabled
                  />
                </Grid>
                <Grid size={6}>
                  <Input
                    label="Prescribed By"
                    name="Prescribed By"
                    value={`Dr. ${data.prescribedby}`}
                    required
                    disabled
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                mt: 4,
                display: "flex",
                justifyContent: "center",
                columnGap: "20px",
                alignItems: "center",
              }}
            >
              <Button
                text="Cancel"
                variant="outlined"
                onClick={() => props.onClose()}
              />
              <Button text="sign" variant="contained" onClick={handleSubmit} />
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AdministerDialog;
